import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../ui/button';

const ActionForm = ({isValid, setIsValid, handlerForm, value, setValue, errorMessage}) => {
  const [message, setMessage] = useState('')

  useEffect(() => {
    if(!isValid && !errorMessage) {
      setMessage('')
    } else if (isValid && !errorMessage) {
      setMessage('')
    } else {
      setMessage(`${errorMessage}`)
      setIsValid(false)
    }
  }, [isValid, errorMessage, setIsValid])

  return (
    <div className="actions-form">
      <div className="actions-title">{isValid  ? 'Great, your code is correct! Go ahead and claim your pack' : 'Enter Code:'}</div>
      <form onSubmit={handlerForm}>
      {isValid 
        ? null 
        : <input
            type="text" 
            onChange={e => setValue(e.target.value)} 
            placeholder="Put Your Code here XXXXX-XXXXX-XXXXX"
            pattern="[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}"
            value={value} 
          />
      }
        <Button type="submit" className={isValid && 'ok'}>{isValid ? 'Claim Pack' : 'Redeem Code'}</Button>
      </form>
      <br />
      <div className={`actions-title ${errorMessage ? 'red' : ''}`}>{message}</div>
    </div>
  )
}

ActionForm.propTypes = {
  isValid: PropTypes.bool.isRequired,
  handlerForm: PropTypes.func.isRequired,
  setIsValid: PropTypes.func.isRequired,
  value: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  errorMessage: PropTypes.string
}

export default ActionForm;